import React from 'react';
import { Link } from 'react-router-dom';
import CountUp from 'react-countup';
import BannerBg from "../../../assets/images/shapes/shape-02.png";
import AboutUs from "../../../assets/images/resource/about-us-new.png";
import shape1 from "../../../assets/images/shapes/shape-01.png";


const About = () => {
  return (
    <section className="about__section p_relative see__pad">
      <div className="pattern-layer">
        <div
          className="pattern-2 p_absolute"
          data-parallax='{"x": -50}'
          style={{ backgroundImage: `url(${BannerBg})` }}
        ></div>
      </div>
      <div className="boild__text">
        <h1>Aurnima Technology Pvt Ltd</h1>
      </div>
      <div className="auto-container">
        <div className="row">
          <div className="col-lg-6 col-md-12">
            <div className="about__block p_relative">
              <figure
                className="wow zoomIn animated"
                data-wow-delay="100ms"
                data-wow-duration="1500ms"
              >
                <img src={AboutUs} alt="" />
              </figure>
              <div
                className="funfact__content about"
                style={{ backgroundImage: `url(${shape1})` }}
              >
                <div className="count-outer count-box">
                  <h1 className="count-text">
                    <CountUp start={0} end={5} /><span>+</span>
                  </h1>

                </div>
                <p>World wide Client</p>
              </div>
            </div>
          </div>
          <div className="col-lg-1"></div>
          <div className="col-lg-5 col-md-12">
            <div className="about__text__block">
              <div className="sub__title">
                <h4>About Us</h4>
              </div>
              <div className="title two">
                <h2>
                  Welcome to Aurnima Technology Pvt Ltd
                </h2>
              </div>
              <div className="texts">
                <p>Aurnima Technology Pvt Ltd is a pioneering software company based in Noida, India. Established with a vision to empower businesses with cutting-edge technology solutions, we are dedicated to creating impactful software, apps, and digital solutions that drive business growth and success. Under the expert leadership of Prince Pandey, Aurnima Technology has swiftly evolved into a trusted name in the industry, providing top-tier solutions to clients worldwide.
                </p>
                <p>In a world where digital transformation is essential, Aurnima Technology stands out as a trusted partner in helping businesses thrive. With our team's expertise, innovation, and commitment to quality, we offer services that empower our clients to reach their highest potential.</p>
              </div>
              <div className="btn-box">
                <Link to="/about" className="theme-btn theme-btn-one">
                  <i className="icon-02"></i> About more
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
